import React, { Component } from "react";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import logo from "../assets/header/logo.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";
export class Header extends Component {
  render() {
    return (
      <>
        <AppBar
          title="Wyzr"
          sx={{
            minHeight: `60px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
            zIndex: 1000,
          }}
        >
          <Container
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={logo}
              alt="wyzr logo"
              style={{ width: 40, height: 40, margin: "0 8px" }}
            />

            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, fontSize: "14px", fontWeight: "bold" }}
            >
              Wyzr
            </Typography>
          </Container>

          <Container
           component={Link}
            to="/profile"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 0.1,
              color: "white",
              textDecoration: "none",
            }}
          >
            <AccountCircleIcon />
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, fontSize: "14px", m: 1 }}
            >
              {this.props.name}
            </Typography>
          </Container>
        </AppBar>
      </>
    );
  }
}

export default Header;